import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { apiDelete } from "../../../utils/api";
import { showError, showSuccess } from "../../../utils/alert";
import { logoutCustomer } from "../../../redux/customerSlice";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

function DeleteAccountPageCustomer() {
  const { t } = useTranslation();

  const dispatch = useDispatch();
          const [loading, setLoading] = useState(false);
          const accessToken = useSelector((s:RootState)=>s.customer.accessToken)
        
      
         const onSubmit = async () => {
            try {
              setLoading(true);
              await apiDelete('deletion/soft-customer',{Authorization:accessToken} ) ;
              showSuccess(t("deleted_account"));
              dispatch(logoutCustomer());
              setLoading(false);
            } catch (err: any) {
              setLoading(false);
              showError(err.message);
            }
          };

  return (
    <div className="min-h-screen bg-light flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-custom-light p-6 text-center">
        <h1 className="text-2xl font-bold text-Black mb-4">
          {t("deleteAccount.title")}
        </h1>

        <p className="text-muted mb-6">
          {t("deleteAccount.warning")}
        </p>

        <div className="flex gap-4 justify-center">
          <button
          onClick={onSubmit}
            className={`bg-danger text-white px-4 py-2 rounded-xl hover:bg-red-700 transition ${loading && "bg-opacity-80"}`}
          >
            {t("deleteAccount.confirmButton")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteAccountPageCustomer;
